import React from 'react';
import styled from "styled-components";
import PriceService from '../../services/PriceService';
import toThousand from '../../services/ToThousandService';
import { useDolarPrice } from '../../hooks/useDolarPrice';

export default function PilesPrice(props) {
    const pricesPiles = PriceService.pricesPiles;
    const [dolar, currentDate] = useDolarPrice();
  
    return (
      <StylePrices>
        <div style={{ backgroundColor: 'var(--colorFondoMain)', padding: '20px' }}>
          <div className="scrollPrice container">
            <h2 style={{ margin: '1rem 0rem', textAlign: 'center' }}>
              Precio de Pilotes por Metro Lineal
            </h2>
  
            <div className="contenedorTablaPrecio">
            {pricesPiles.map((grupo, i) => (
                <div key={i} style={{textAlign:'center'}}>
                    <h3 style={{color: 'var(--colorTerciario)'}}>{grupo.diametro}</h3>
                    <table className="tablaPrecio">
                    <thead>
                        <tr className="subTituloPrice">
                        <td>Cantidad</td>
                        <td>Código</td>
                        <td style={{ width: '30%' }}>Descripción</td>
                        <td className="columnaDolar">Precio U$S + IVA</td>
                        <td className="columnaPesos">Precio $ + IVA</td>
                        </tr>
                    </thead>
                    <tbody>
                        {grupo.productos.map((item, index) => {
                        const rowClassName = index % 2 === 0 ? "filaPricePar" : "filaPriceImpar";

                        if (item.total !== undefined) {
                            return (
                            <React.Fragment key={item.id || `total-${index}`}>
                                <tr className="filaTotal">
                                <td colSpan={3} style={{ textAlign: 'right', paddingRight: '2rem', fontWeight: 'bold' }}>Total por Metro Lineal:</td>
                                <td className="columnaDolar" style={{ fontWeight: 'bold' }}>{toThousand(item.total)}</td>
                                <td className="columnaPesos" style={{ fontWeight: 'bold' }}>{toThousand(item.total * dolar)}</td>
                                </tr>
                                <tr><td colSpan={5}><br /></td></tr>
                            </React.Fragment>
                            );
                        }

                        return (
                            <tr key={item.id} className={rowClassName}>
                                <td>{item.cantidad}</td>
                                <td>{item.codigo}</td>
                                <td>{item.desc}</td>
                                <td className="columnaDolar">{toThousand(item.precio * item.cantidad)}</td>
                                <td className="columnaPesos">{toThousand(item.precio * item.cantidad * dolar)}</td>
                            </tr>
                        );
                        })}
                    </tbody>
                    </table>
                </div>
))}

            </div>
          </div>
        </div>
      </StylePrices>
    );
  }
  

const StylePrices = styled.div`
    width: 100%;
    .iconScroll{
        display: flex;
        justify-content: center;
        color: var(--colorPrimario);
        @media (min-width: 992px){
            display:none;
        }
    }
    .scrollPrice{
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-bottom: 2rem;
        @media(min-width: 992px){
            display: flex;
            align-items: center;
        }
    }
    .contenedorTablaPrecio::-webkit-scrollbar{
        height: 15px;
        border-radius: 10px;
        background-color: var(--colorSecundario);
    }
    .contenedorTablaPrecio::-webkit-scrollbar-thumb{
        background-color: var(--colorPrimario);
        border-radius: 10px;
        width: 5px;
    }
    .contenedorTablaPrecio{
        overflow-x: scroll;
        flex-direction: column;
        width: 100%;
        @media (min-width: 992px){
            width: 100%;
            display: flex;
            flex-direction: column ;
            justify-content: space-between;
            margin-top: 2rem;
            ::-webkit-scrollbar {display:none;} //Oculta la barra de scroll sin perder la funcion
        }
    }
    .tablaPrecio{
        margin-top: 0.5rem;
        margin-bottom: 1.5rem;
        width: 100%;
        border-collapse:collapse;
        margin-right: 10px;
        text-align: center;
        @media (min-width: 768px){
            justify-self: flex-end; /* Alinear tabla a la derecha */
        }
    }
    .tituloPrice{
        background-color: var(--colorPrimario);
        margin: 20px;
    }
    .tituloPrice td{
        color: #fff;
        font-family: var(--fuenteSecundaria);
        font-weight: 700;
        font-size: 20px;
        padding: 20px;
    }
    .subTituloPrice{
        background-color: var(--colorGris);
        font-family: var(--fuenteSecundaria);
        color: #fff;
        padding: 5px;
    }
    .subTituloPrice td{
        padding: 10px;
        width: 10%;
        font-weight: 600;
    }
    .filaPricePar {
        background-color: var(--colorFilaTabla);
        font-weight: 500;
    }
    .filaPricePar td{
        padding: 5px;
        font-weight: 500;
    }
    .filaPriceImpar{
        background-color: #fff;
        font-weight: 500;
    }
    .filaPriceImpar td{
        padding: 5px;
        font-weight: 500;
    }
    .columnaDolar{
        background-color: var(--colorTerciario);
        color: #fff;
    }
    .columnaPesos{
        background-color: var(--colorPrimario);
        color: #fff;
    }
    td {
        font-size: 13px;
        @media (min-width: 768px){
            font-size: 15px;
        }
    }
`